import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef } from "vue"
import _imports_0 from '../assets/images/home/PDF.png'


const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "home" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "statist" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = { class: "all-link" }
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "attention" }
const _hoisted_10 = { class: "right-title" }
const _hoisted_11 = { class: "operation" }
const _hoisted_12 = { class: "right-title" }

import { CirclePlus, ArrowRight } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { useGlobalStore } from '@/store/modules/global'
import { fetchTodoList, fetchStatist } from '@/api/project'
import CreateProject from '@/components/CreateProject/index.vue'
import Project from './Project.vue'


export default {
  __name: 'Home',
  setup(__props) {

const router = useRouter()
const globalStore = useGlobalStore()

const statistList = ref([
  { label: '进行中项目数', key: 'doing', value: '' },
  { label: '项目总数', key: 'all', value: '' },
  { label: '服务客户数', key: 'customer', value: '' },
  { label: '系统服务天数', key: 'workDay', value: '' },
])

const createProjectVisible = ref(false)

const handleStatist = () => {
  fetchStatist().then(res => {
    statistList.value.forEach(item => {
      item.value = res[item.key]
    })
  })
}

const handleGoWriting = () => {
  createProjectVisible.value = true
}

const handleCreateSuccess = (result) => {
  router.push(`/writing/step1?id=${result}`)
}

onMounted(() => {
  handleStatist()
})

return (_ctx, _cache) => {
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_statistic = _resolveComponent("el-statistic")
  const _component_router_link = _resolveComponent("router-link")
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "create-btn",
          onClick: handleGoWriting
        }, [
          _createVNode(_component_el_icon, { size: 30 }, {
            default: _withCtx(() => [
              _createVNode(_unref(CirclePlus))
            ]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" 新建项目 ", -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statistList), (item) => {
            return (_openBlock(), _createBlock(_component_el_statistic, {
              key: item.value,
              title: item.label,
              value: item.value
            }, null, 8, ["title", "value"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, { to: "/project" }, {
              default: _withCtx(() => [
                _cache[2] || (_cache[2] = _createTextVNode(" 查看全部 ", -1)),
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowRight))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(Project, { api: _unref(fetchTodoList) }, null, 8, ["api"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_svg_icon, {
                name: "attention.png",
                size: 18
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" 注意事项 ", -1))
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", null, "本工具致力于提供优质、高效的AI审核服务，内容须基于真实发明创造，请遵守法规和道德规范，勿滥用本工具进行非正常申请行为，保障知识产权保护的公平性和有效性。", -1))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_svg_icon, { name: "operate.png" }),
              _cache[5] || (_cache[5] = _createTextVNode(" 操作手册 ", -1))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", null, "交底书审核.pdf", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "operation-link" }, [
              _createTextVNode("点击"),
              _createElementVNode("a", null, "下载到本地"),
              _createTextVNode("或"),
              _createElementVNode("a", null, "在线预览")
            ], -1))
          ])
        ])
      ]),
      _createVNode(CreateProject, {
        visible: _unref(createProjectVisible),
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => (_isRef(createProjectVisible) ? (createProjectVisible).value = $event : null)),
        onSuccess: handleCreateSuccess
      }, null, 8, ["visible"])
    ])
  ]))
}
}

}